var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.978516 7.55933C0.978516 3.69937 4.11856 0.559326 7.97852 0.559326C11.8385 0.559326 14.9785 3.69937 14.9785 7.55933C14.9785 11.4193 11.8385 14.5593 7.97852 14.5593C4.11856 14.5593 0.978516 11.4193 0.978516 7.55933ZM7.73466 9.86752L11.5264 6.07593C11.7544 5.84778 11.7544 5.47917 11.5264 5.25113C11.2982 5.02298 10.9296 5.02298 10.7016 5.25113L7.32227 8.63033L5.83887 7.14693C5.61072 6.91878 5.24211 6.91878 5.01407 7.14693C4.78592 7.37497 4.78592 7.74368 5.01407 7.97173L6.90987 9.86752C7.02362 9.98128 7.17294 10.0385 7.32227 10.0385C7.47159 10.0385 7.62091 9.98128 7.73466 9.86752Z",
    fill: "#358613"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/greenTick.4d1b64eefc9f9c97983e70fd829dc94a.svg";
export { ForwardRef as ReactComponent };